import React, { createContext, useState, useEffect } from 'react';
import { risapi } from '../api/risapi';
import { useNavigate, useLocation } from 'react-router-dom';


const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  
  

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    console.log("storedToken",storedToken);
    
    if (storedToken) {
      setToken(storedToken);
    }
   
   
  },[]); // ** FIX: Added empty dependency array so this only runs once on mount **

  useEffect(() => {
    const fetchUserData = async () => {
     
      if (token) {
        console.log("calling here");
        
        try {
          const response = await risapi.get('/api/user', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log("data response",response.data);
          
          setUser(response.data);

          // ** START: REDIRECT LOGIC **
          // Only redirect if the user is currently on the login page
          if (location.pathname === '/login') {
            if (response.data.is_milma_admin) {
              navigate('/milma-admin/home');
            } else {
              navigate('/franchisee_user/home');
            }
          }
          // ** END: REDIRECT LOGIC **

        } catch (error) {
          console.error('Error fetching user data:', error);
          // ** FIX: Clear bad token and send to login **
          setToken(null);
          setUser(null);
          localStorage.removeItem('token');
          navigate('/login');
        }
      }
     else {
      // No token, set user to null
      setUser(null);
     
    }
      
    };

    fetchUserData();
  }, [token, navigate, location.pathname]); // Add dependencies

  const login = (token) => {
    console.log("tokenval",token);
    
    setToken(token);
    localStorage.setItem('token', token);
  };

  

  return (
    <AuthContext.Provider value={{ user, token, login,setToken,setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
